export const getTicketPrintStyle = printWidth => {
  const isNarrow = printWidth === '2'

  return {
    fontSize: isNarrow ? 11 : 13,
    titleFontSize: isNarrow ? 16 : 20,
  }
}

export const ticketPageStyle = `
  html, body { margin: 0 !important; padding: 0 !important; }
  .thermal-ticket { box-sizing: border-box; padding: 0 3mm; color: #000; font-family: Arial, sans-serif; line-height: 1.4; }
  .thermal-ticket table { font-family: inherit; color: inherit; }
  .thermal-ticket table.ticket-modal > tbody > tr > td { font-size: inherit; font-weight: inherit; }
  .thermal-ticket > div[style] { margin-left: 0 !important; margin-right: 0 !important; }
  .thermal-ticket > div > table { width: 100% !important; }
  .thermal-ticket td:last-child { white-space: nowrap; }
  .thermal-ticket thead { display: table-row-group; }
`

export const printContinuousTicket = async iframe => {
  const doc = iframe.contentDocument
  const win = iframe.contentWindow
  const ticket = doc.querySelector('.thermal-ticket')
  if (!ticket) {
    win.focus()
    win.print()
    return
  }

  // Se mide el documento final, con sus estilos, fuentes e imágenes cargados.
  if (doc.fonts) await doc.fonts.ready
  await Promise.all(Array.from(doc.images).map(img => {
    if (img.complete) return Promise.resolve()
    return new Promise(resolve => {
      img.addEventListener('load', resolve, { once: true })
      img.addEventListener('error', resolve, { once: true })
    })
  }))
  const widthMm = ticket.dataset.printWidth === '3' ? 80 : 58
  ticket.style.width = `${widthMm}mm`
  doc.body.style.width = `${widthMm}mm`
  const heightPx = Math.max(ticket.scrollHeight, ticket.getBoundingClientRect().height)
  const heightMm = Math.ceil(heightPx * 25.4 / 96) + 2
  const page = doc.createElement('style')
  page.textContent = `@page { size: ${widthMm}mm ${heightMm}mm; margin: 0; }`
  doc.head.appendChild(page)
  win.focus()
  win.print()
}
